export default {
    workOrder_workOrderTab_workOrderNumber: "Nº Orden de Trabajo",
    workOrder_workOrderTab_scheduledDate: "Fecha de Programación",
    workOrder_workOrderTab_status: "Estado",
    workOrder_workOrderTab_statusUpdatedOn: "Fecha de Actualización",
    workOrder_workOrderTab_address: "Dirección",
    workOrder_workOrderTab_type: "Tipo",
    workOrder_workOrderTab_duration: "Duración (minutos)",
    workOrder_workOrderTab_severity: "Severidad",
    workOrder_workOrderTab_viewAnswer: "Ver respuesta",
};